import React from 'react';

export default class InitialMessage extends React.PureComponent {
  render(): React.ReactNode {
    return (
      <div style={{ height: '250px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <span className="text-center">Please click Apply Button to view  Grid</span>
      </div>
    );
  }
}